<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
// Reasons are renamed and archived from the list (STG-WEB-16: a reason is
// only a name, so it has no page). Old links land on the list; a named
// redirect keeps the :org param.
definePage({
  redirect: { name: '/(app)/[org]/settings/(organizations)/shift-reasons' },
  meta: {
    requiresAuth: true,
    requiresOrganisation: true,
  },
})
</script>

<template>
  <div />
</template>
